import React from 'react'
import { Link } from "react-router-dom";
import { List, ListItem, ListItemButton, ListItemText, ListItemIcon, Divider, Collapse } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

export interface INestableMenuItemProps {
  name: string,
  link: string,
  icon?: JSX.Element,
  items?: INestableMenuItemProps[],
}

export const NestableMenuItem = (props: INestableMenuItemProps) => {
  const { name, link, icon, items = [] } = props;
  const isExpandable = items && items.length > 0;
  const [open, setOpen] = React.useState(false);

  function handleClick() {
    setOpen(!open)
  }

  const MenuItemRoot = (
    <ListItem>
      {isExpandable ? (
        <ListItemButton onClick={handleClick}>
          {/* Display an icon if any */}
          {icon && (
            <ListItemIcon>
              {icon}
            </ListItemIcon>
          )}
          <ListItemText primary={name} inset={!!icon} />
          {!open && <ExpandMore />}
          {open && <ExpandLess />}
        </ListItemButton>
      ) : (
        <ListItemButton component={Link} to={link}>
          {icon && (
            <ListItemIcon>
              {icon}
            </ListItemIcon>
          )}
          <ListItemText primary={name} inset={!!icon} />
        </ListItemButton>
      )}
    </ListItem>
  )

  const MenuItemChildren = isExpandable ? (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Divider />
      <List component="div" disablePadding>
        {items.map((item, index) => (
          <NestableMenuItem {...item} key={index} />
        ))}
      </List>
    </Collapse>
  ) : null;

  return (
    <>
      {MenuItemRoot}
      {MenuItemChildren}
    </>
  );
}

